import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getGrowersFromAPI = async ({
    page,
    pageSize = 10,
    search,
    country,
    cmCrop,
    hasFields,
    hasReports,
    includeChildren = true,
    node,
    nodeType,
    nodeSubtype,
    ordering,
    appInstance,
    year,
    parentIn,
    excludeTargetNode = false,
}: {
    page: number;
    pageSize?: number;
    search?: string;
    country?: string;
    cmCrop?: string;
    hasFields?: string;
    hasReports?: boolean;
    includeChildren?: boolean;
    node?: number;
    nodeType?: string;
    nodeSubtype?: string;
    ordering?: string;
    appInstance: number;
    year?: number;
    parentIn?: number[];
    excludeTargetNode?: boolean;
}) => {
    try {
        const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/growers/`, window.location.origin);

        const params = new URLSearchParams();
        params.append('page', String(page));
        params.append('page_size', String(pageSize));
        if (search) params.append('search', search);
        if (country) params.append('country', country);
        if (cmCrop) params.append('cm_crop', cmCrop);
        if (hasFields) params.append('has_fields', hasFields);
        if (hasReports !== undefined) params.append('has_reports', String(hasReports));
        if (includeChildren !== undefined) params.append('include_children', String(includeChildren));
        if (node) params.append('node', String(node));
        if (nodeType) params.append('node_type', nodeType);
        if (nodeSubtype) params.append('node_subtype', nodeSubtype);
        if (ordering) params.append('ordering', ordering);
        if (appInstance) params.append('app_instance', String(appInstance));
        if (year) {
            params.append('campaign', String(year));
            params.append('year', String(year));
        }
        if (parentIn && Array.isArray(parentIn)) {
            params.append('parent__in', parentIn.join(','));
        }
        if (excludeTargetNode !== undefined) params.append('exclude_target_node', String(excludeTargetNode));

        const response = await axFetch.get(`${apiUrl}?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching growers:', error);
        throw error;
    }
};
